import { CashCartCalculationStrategy } from './strategies/cash-cart-calculation.strategy';
import { CartCalculationStrategy } from './interfaces/cart-calculation-strategy.interface';
import { RegularCartCalculationStrategy } from './strategies/regular-cart-calculation.strategy';

export class CartCalculationFactory {
	private readonly regularStrategy = new RegularCartCalculationStrategy();
	private readonly cashStrategy = new CashCartCalculationStrategy();

	create(cashMode: boolean): CartCalculationStrategy {
		return cashMode ? this.cashStrategy : this.regularStrategy;
	}
}
